import { Order } from 'entities/orders/model/types';
import { FC, useEffect, useMemo, useState } from 'react';
import { OrderAmountBlock, OrderAmountContainer } from './styles';
import { DEPOSIT_STATUSES } from 'shared/consts';

type StatusType = {
  name: string;
  text: string;
  icon: string;
  color: string;
  bg?: string;
}

export const OrderAmount: FC<{ order: Order }> = ({ order }) => {
  const [currentStatus, setCurrentStatus] = useState<StatusType | null>();

  useEffect(()=>{
    const status = order?.deposit?.status;
    if (status) {
      const finded = DEPOSIT_STATUSES.find(el=>el.name===status) || DEPOSIT_STATUSES.find(el=>el.name==='default');
      if (finded) {
        setCurrentStatus(finded);
      } else {
        setCurrentStatus({
          name: '',
          text: '',
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 640 640"><path fill="#577CF0" d="M208 96c-17.7 0-32 14.3-32 32v208h-40c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v48h-40c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h152c13.3 0 24-10.7 24-24s-10.7-24-24-24H240v-48h112c79.5 0 144-64.5 144-144S431.5 96 352 96zm144 224H240V160h112c44.2 0 80 35.8 80 80s-35.8 80-80 80"/></svg>`,
          color: '',
          bg: 'transparent',
        })
      }
    } else {
      setCurrentStatus({
        name: '',
        text: '',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 640 640"><path fill="#577CF0" d="M208 96c-17.7 0-32 14.3-32 32v208h-40c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v48h-40c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h152c13.3 0 24-10.7 24-24s-10.7-24-24-24H240v-48h112c79.5 0 144-64.5 144-144S431.5 96 352 96zm144 224H240V160h112c44.2 0 80 35.8 80 80s-35.8 80-80 80"/></svg>`,
        color: '',
        bg: 'transparent',
      })
    }
  }, [order])

  const amount = useMemo(() => {
    if (order.prepayment_amount) return Number(order.prepayment_amount).toLocaleString('ru-RU');

    if (order?.deposit?.amount) {
      const amountNum = typeof order?.deposit?.amount === 'number' ? order?.deposit?.amount : parseFloat(order?.deposit?.amount);
      return amountNum.toLocaleString('ru-RU');
    }

    return '';
  }, [order.deposit, order.prepayment_amount])

  // const providerIcon = useMemo(() => {
  //   return rouble;

  //   return order?.deposit?.provider?.backend?.icon;
  // }, [order.deposit, order.prepayment_amount])

  if ((!order.deposit&&!order.prepayment_amount)||!currentStatus) return <></>

  return (
      <OrderAmountContainer>
        <OrderAmountBlock
          $color={currentStatus.color}
          $bg={currentStatus.bg}
        >
          <i dangerouslySetInnerHTML={{__html:currentStatus.icon}}></i>
          <span>{amount}</span>
        </OrderAmountBlock>
        {/* <OrderAmountProviderIcon>
          <Img src={providerIcon} $size="small" />
        </OrderAmountProviderIcon> */}
      </OrderAmountContainer>
  );
};
